
(function (backOffice, $) {
    backOffice.FulfilmentService = (function (id) {

        const btnDisableService = '#btnDisable';
        const btnEnableService = '#btnEnable';
        var serviceId;

        var initialize = function (id) {
            serviceId = id;
            setFulfimentServiceById(serviceId);
        };

        var setFulfimentServiceById = function () {
            BackOffice.ToggleLoader(true);
            $.ajax({
                method: 'GET',
                async: true,
                url: window.location.origin + '/dotnet/admin/api/getfulfilmentservice?id=' + serviceId,
                dataType: 'json',
                contentType: 'application/json',
                success: function (service) {
                    chooseEnableOrDisableButton(service.enabled);
                    BackOffice.ToggleLoader(false);
                },
                error: function (request, status, error) {
                    BackOffice.ToggleLoader(false);
                    alert(request.responseJSON.exceptionMessage);
                }
            });

        };

        var updateFulfimentService = function (isEnabled, confirmationMessage) {
            if (confirmationMessage && isEnabled === false && confirm(confirmationMessage) === false) {
                return;
            }
            BackOffice.ToggleLoader(true);
            $.ajax({
                method: 'POST',
                async: true,
                data: JSON.stringify({
                    enabled: isEnabled
                }),
                url: window.location.origin + '/dotnet/admin/api/updatefulfilmentservice?id=' + serviceId,
                dataType: 'json',
                contentType: 'application/json',
                success: function (service) {
                    chooseEnableOrDisableButton(service.enabled);
                    BackOffice.ToggleLoader(false);
                },
                error: function (request, status, error) {
                    BackOffice.ToggleLoader(false);
                    alert(request.responseJSON.exceptionMessage);
                }
            })
        };

        var chooseEnableOrDisableButton = function (isEnableService) {
            if (isEnableService) {
                $(btnDisableService).removeClass("hide");
                $(btnDisableService).addClass("display");


                $(btnEnableService).removeClass("display");
                $(btnEnableService).addClass("hide");
            }
            else {
                $(btnEnableService).removeClass("hide");
                $(btnEnableService).addClass("display");


                $(btnDisableService).removeClass("display");
                $(btnDisableService).addClass("hide");
            }
        };

        return $.extend(backOffice.FulfilmentService, {
            Init: initialize,
            Update: updateFulfimentService
        });
    })();

    return backOffice.FulfilmentService;
})(BackOffice || {}, jQuery);